import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config';
import '../Styles/AnnouncementBar.css';

const IconTimer = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
    </svg>
);

const AnnouncementBar = () => {
    const [discount, setDiscount] = useState(null);
    const [timeLeft, setTimeLeft] = useState({});

    useEffect(() => {
        const fetchDiscount = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/admin/order-discounts`);
                if (response.ok) {
                    const data = await response.json();
                    if (Array.isArray(data)) {
                        const active = data.find(d => d.is_active === 1);
                        if (active) {
                            setDiscount(active);
                            document.body.classList.add('has-announcement');
                        } else {
                            document.body.classList.remove('has-announcement');
                        }
                    } else {
                        document.body.classList.remove('has-announcement');
                    }
                }
            } catch (err) {
                console.error('Error fetching announcement discount:', err);
            }
        };
        fetchDiscount();

        return () => document.body.classList.remove('has-announcement');
    }, []);

    useEffect(() => {
        if (!discount || !discount.end_date) return;

        const calculateTimeLeft = () => {
            const end = new Date(discount.end_date);
            const now = new Date();
            const diff = end - now;

            if (diff <= 0) return {};

            return {
                days: Math.floor(diff / (1000 * 60 * 60 * 24)),
                hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((diff / 1000 / 60) % 60),
                seconds: Math.floor((diff / 1000) % 60)
            };
        };

        setTimeLeft(calculateTimeLeft());

        const timer = setInterval(() => {
            const newTime = calculateTimeLeft();
            setTimeLeft(newTime);
            if (Object.keys(newTime).length === 0) {
                clearInterval(timer);
                setDiscount(null);
                document.body.classList.remove('has-announcement');
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [discount]);

    if (!discount) return null;

    const dType = discount.type?.toLowerCase();
    const minPrice = parseFloat(discount.min_price) || 0;
    const discountValueText = dType === 'percentage'
        ? `${Math.round(discount.value)}% OFF`
        : `$${parseFloat(discount.value).toFixed(2)} OFF`;
    const thresholdText = minPrice > 0
        ? ` on orders above $${minPrice.toFixed(2)}!`
        : ' on all orders!';
    const discountMsg = `${discountValueText}${thresholdText}`;

    const hasTimeLeft = Object.keys(timeLeft).length > 0;

    return (
        <div className="announcement-bar">
            <div className="announcement-content">
                <span className="announcement-text">
                    {discountMsg} {hasTimeLeft && (
                        <span className="announcement-countdown">
                            <IconTimer />
                            Ends in: <strong>
                                {timeLeft.days > 0 && `${timeLeft.days}d `}
                                {String(timeLeft.hours).padStart(2, '0')}h :
                                {String(timeLeft.minutes).padStart(2, '0')}m :
                                {String(timeLeft.seconds).padStart(2, '0')}s
                            </strong>
                        </span>
                    )}
                </span>
            </div>
        </div>
    );
};

export default AnnouncementBar;
